import { CantileverButton } from 'components/CantileverButton'
import { useChatbotAttachments } from 'features/chatbot/contexts/ChatbotAttachmentContext'
import { X } from 'lucide-react'
import React from 'react'
import styled from 'styled-components'

const PillsContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 0.5rem;
  align-items: center;
`

const Pill = styled.div`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.25rem 0.25rem 0.25rem 0.625rem;
  background-color: ${({ theme }) => theme.forecast.primary}20;
  border: 1px solid ${({ theme }) => theme.forecast.primary}40;
  border-radius: 1rem;
  font-size: 0.75rem;
  color: ${({ theme }) => theme.forecast.primary};
  max-width: 12rem;
`

const PillText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const RemoveButton = styled(CantileverButton)`
  min-height: 1.125rem;
  width: 1.125rem;
  flex-shrink: 0;
  color: ${({ theme }) => theme.forecast.primary};
`

export const AttachmentPills: React.FC = () => {
  const { attachments, removeAttachment } = useChatbotAttachments()

  if (attachments.length === 0) {
    return null
  }

  return (
    <PillsContainer>
      {attachments.map((attachment) => (
        <Pill key={attachment.id}>
          <PillText title={attachment.displayTitle}>
            {attachment.displayTitle}
          </PillText>
          <RemoveButton
            iconOnly
            ghost
            onClick={() => removeAttachment(attachment.id)}
            aria-label={`Remove ${attachment.displayTitle}`}>
            <X size={12} />
          </RemoveButton>
        </Pill>
      ))}
    </PillsContainer>
  )
}
